import styled from 'styled-components';

export const ImgWrap = styled.div`
  > img {
    width: 100%;
  }
`;

export const BGWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  /* border: 1px solid #f2f2f2; */
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;


  // 필요할때 사용
  //@media only screen and (max-width: 640px) {
  //  border: 0;
  //}
`;
